/**
 *
 * @param entity
 * @param appResourceClass
 * @param message
 */
export function assertType(entity, appResourceClass, message = null) {
    if (!(entity instanceof appResourceClass)) {
        throw new Error(message ? message : `Invalid entity. Expecting ${appResourceClass}`);
    }
}
